import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CardLinkingQuery, CardLinkOffer, CardLinkOffersService } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-card-link-offer-item',
  templateUrl: './card-link-offer-item.component.html',
  styleUrls: ['./card-link-offer-item.component.scss'],
})
export class CardLinkOfferItemComponent implements OnInit, OnDestroy {
  @Input() cardLinkOffer: CardLinkOffer;
  @Input() lcid: string;
  private _destroyed$ = new Subject<void>();
  activatedOfferID: number = 0;
  constructor(
    private cardLinkOffersService: CardLinkOffersService,
    private router: Router,
    private cardLinkingQuery: CardLinkingQuery,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {}

  /**
   * activate offer by offer ID
   * navigate to the external url
   * navigate to detail page
   * when user click on any button this function will exicute and check
   * some condition according to the offerTyper and CustomerOfferStatus
   * if offer is already active it will move on detail page
   * if offertype !=6 it will call the api to get the url and then will move on
   * company website
   * if offer is not activated it will call the api to activate the offer
   * @param offer to get the offer id customerOfferStatus offerType and imageurl
   * @param content to open the ngbModel to display the navigation progress
   */

  offerAction(offer: CardLinkOffer, cardNotLinkModel: any) {
    if (offer.OfferType == 6 && offer.CustomerOfferStatus == 0) {
      this.cardLinkingQuery
        .selectCount()
        .pipe(takeUntil(this._destroyed$))
        .subscribe((count) => {
          if (count > 0) {
            this.activateOffer(offer);
          } else {
            this.openCardNotLinkModal(cardNotLinkModel);
          }
        });
    } else {
      this.router.navigateByUrl('/offerdetail/' + offer.OfferId);
    }
  }

  /**
   * activate offer by offer ID
   * @param offer to get the offerId to activate the offer by Id
   */
  activateOffer(offer: CardLinkOffer) {
    this.cardLinkOffersService.activateOffer(offer.OfferId).pipe(takeUntil(this._destroyed$)).subscribe();
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  /**
   * open NgbModal for offers after successfully link the card.
   * callbackSuccess will call when card successfully link and callbackFailed will call if there is any issue.
   * @param content to open the NgbModal for offers.
   */
  openCardNotLinkModal(cardNotLinkModel: any): void {
    this.modalService.open(cardNotLinkModel, { centered: true, ariaLabelledBy: 'modal-basic-title' });
  }

  cancel(): void {
    this.modalService.dismissAll();
    this.router.navigateByUrl('/linkcard');
  }
}
